import React from 'react'
import styled, {ThemeProvider} from 'styled-components'
import {Box, Hide, IconButton, Link, LogoSquare} from '@miro-site/core'
import {theme} from '@miro-site/design-tokens'

const Footer = styled(Box).attrs({
  as: 'footer',
  $styles: {
    background: 'primaryWhite',
  },
})``

const Wrapper = styled(Box).attrs({
  $styles: {
    maxWidth: 1680,
    position: 'relative',
    ':before': {
      content: `""`,
      background: 'rgba(5, 0, 56, 0.2)',
      height: '1px',
      position: 'absolute',
      top: [40, 60],
      left: [20, 40],
      right: [20, 40],
    },
  },
  $mx: 'auto',
  $pt: [81, 101],
  $pl: [20, 40],
  $pr: [20, 40],
  $pb: [20, 40],
})``

const Container = styled(Box).attrs({
  $styles: {
    display: [undefined, 'flex'],
    alignItems: [undefined, 'center'],
    justifyContent: [undefined, 'space-between'],
  },
})``

const Links = styled(Box).attrs({
  $styles: {
    fontSize: 18,
    lineHeight: 24,
  },
})``

const InlineLink = styled(Link).attrs({
  $styles: {
    borderBottom: '1px solid',
    borderColor: 'rgba(5, 0, 56, 0.2)',
    transition: 'border 250ms ease',
    ':hover': {
      borderColor: 'transparent',
    },
    ':focus': {
      ...theme.focus.outlines.withOffset,
    },
  },
})``

const Copyright = styled(Box).attrs({
  as: 'span',
  $ml: [null, 98],
})``

const BottomWrapper = styled(Box).attrs({
  $styles: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  $mt: [40, null],
})``

const AcquisitionFooter: React.FC = () => {
  return (
    <ThemeProvider
      theme={defaultTheme => ({
        ...defaultTheme,
        multipliers: {
          small: value => `${value / 3.65}vw`,
          mediumUp: value => `${value}px`,
          mediumDown: value => `${value / 12}vw`,
          large: value => `${value}px`,
        },
      })}
    >
      <Footer>
        <Wrapper>
          <Hide $on={['small']}>
            <Container>
              <IconButton
                icon={<LogoSquare />}
                label="Miro"
                href="https://miro.com/"
                title="Miro"
              />
              <Links>
                <InlineLink href="/legal/terms-of-service/">Terms</InlineLink> and{' '}
                <InlineLink href="/legal/privacy-policy/">Privacy Policy</InlineLink>
                <Copyright>
                  © 2022{' '}
                  <InlineLink href="https://miro.com/" title="Miro">
                    Miro
                  </InlineLink>
                </Copyright>
              </Links>
            </Container>
          </Hide>

          <Hide $on={['mediumDown', 'mediumUp', 'large']}>
            <Container>
              <Links>
                <InlineLink href="/legal/terms-of-service/">Terms</InlineLink> and{' '}
                <InlineLink href="/legal/privacy-policy/">Privacy Policy</InlineLink>
              </Links>

              <BottomWrapper>
                <Links>
                  <Copyright>
                    © 2022{' '}
                    <InlineLink href="https://miro.com/" title="Miro">
                      Miro
                    </InlineLink>
                  </Copyright>
                </Links>

                <IconButton
                  icon={<LogoSquare />}
                  label="Miro"
                  href="https://miro.com/"
                  title="Miro"
                />
              </BottomWrapper>
            </Container>
          </Hide>
        </Wrapper>
      </Footer>
    </ThemeProvider>
  )
}

export default AcquisitionFooter
